//热点点击事件

function onSceneHotspotClick(data) {
  //场景切换热点
  const { scene_name } = data;
  if (!scene_name) return;
  this.changeSceneByName(scene_name);
  this.updateSceneListByName(scene_name);
}

function onLinkHotspotClick(data) {
  //外链热点
  this.openLink(data);
}

function onPhoneHotspotClick(data) {
  //电话热点
  this.callPhone(data);
}

function onImgHotspotClick(data) {
  //图片热点
  this.showSwiper(data);
}

function onImgTextHotspotClick(data) {
  //图文热点
  this.showSwiper(data);
}

function onMusicHotspotClick(data) {
  //音乐热点
  this.setHotspotMusic(data);
}

function onRingsHotspotClick(data) {
  //环物热点
  this.showRings(data);
}

function onVideoHotspotClick(data) {
  //视频热点
  this.showVideo(data);
}

function onIframeHotspotClick(data) {
  //iframe热点
  this.showIframe(data);
}

function onArticleHotspotClick(data) {
  //富文本热点
  this.showArticle(data);
}

function on3DHotspotClick(data) {
  //模型热点
  const { on3DHotspotClick } = this.props;
  if (on3DHotspotClick && typeof on3DHotspotClick === 'function') {
    on3DHotspotClick(data);
  }
}

function onRichtexthotspotClick(data) {
  //VR云富文本热点
  this.showRichText(data)
}

function onNavigationhotspotClick(data) {
  this.openNavigation(data)
}

export default {
  onSceneHotspotClick,
  on3DHotspotClick,
  onPhoneHotspotClick,
  onLinkHotspotClick,
  onImgHotspotClick,
  onArticleHotspotClick,
  onIframeHotspotClick,
  onVideoHotspotClick,
  onRingsHotspotClick,
  onMusicHotspotClick,
  onImgTextHotspotClick,
  onRichtexthotspotClick,
  onNavigationhotspotClick
};
